<template>
  <div class='mt-1'>
    <b-modal
      ref='selectRoles'
      id='selectRoles'
      hide-footer
      hide-header
      header-bg-variant='info'
      header-text-variant='light'
      size='xl'
      @show='showModal()'
    >
      <b-overlay
        :show='lookingForCompany'
        rounded
        opacity='0.6'
        spinner-small
        spinner-variant='primary'
        class='d-inline-block w-100'
        style='min-height: 150px'
      >
        <section class='modal-font-family'>
          <section class='mb-3'>
            <section class='d-flex align-content-center justify-content-between '>
              <section>
                <p class='products-title mt-1'>
                  Selecione os cargos para o setor
                </p>
              </section>

              <section>
                <b-icon
                  style='cursor: pointer'
                  @click='closeModal()'
                  class='ml-1'
                  font-scale='2.5'
                  icon='x'
                  color='#262626'
                >
                </b-icon>
              </section>
            </section>
            <section>
              <p class='products-sub-title'>
                Selecione os cargos que serão adicionados ao setor. É possível adicionar mais de um.
              </p>
            </section>
          </section>

          <section
            style='display: grid;  grid-template-columns: repeat(auto-fill, minmax(25%, auto)); min-height: 80px'
          >
            <b-form-checkbox-group
              v-model='selected'
              v-for='(role, i) in roles'
              :key='i'
              class='product'
              size='lg'
            >
              <b-form-checkbox
                class=''
                :value='role._id'
              >
                <p class='word-break product-name mt-2'>{{ role.name }}</p>
              </b-form-checkbox>
            </b-form-checkbox-group>
          </section>

          <section class='d-flex justify-content-between mt-4'>
            <base-button
              class='w-25 mr-3 btn-cancel'
              @click='closeModal()'
            >
              <span>Cancelar</span>
            </base-button>

            <b-overlay
              :show='loading'
              rounded
              opacity='0.6'
              spinner-small
              spinner-variant='primary'
              class='d-inline-block w-75'
            >
              <base-button
                class='w-100 btn-add d-flex align-items-center justify-content-center'
                @click='create()'
              >
                <span class='mr-2'> Finalizar adição de cargos </span>
              </base-button>
            </b-overlay>
          </section>
        </section>

        <template v-slot:overlay>
          <div class='text-center loading-spinner'>
            <b-spinner
              style='width: 2rem; height: 2rem'
              variant='primary'
              label='Large Spinner'
            ></b-spinner>
            <h6 class='text-primary'>Buscando setor...</h6>
          </div>
        </template>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'SelectRoles',
  components: {},
  props: {
    sectorId: {
      type: String,
      required: false,
      default: null
    },
  },
  data() {
    return {
      loading: false,
      lookingForCompany: false,
      roles: [],
      selected: [],
      sector: {
        name: '',
        _id: null
      }
    }
  },
  async mounted() {
    try {
    } catch (e) {
    }
  },
  computed: {
    user() {
      return this.$store.getters['user/current']
    },
    disabled() {
      return this.selected.length === 0
    },
    ...mapGetters('companyLegalConsultation', {
      importedCompany: 'importedCompany'
    })
  },
  methods: {
    ...mapActions('sector', {
      handleGet: 'handleGet',
      handleBindRoles: 'handleBindRoles',
    }),
    ...mapActions('productLegalConsultation', {
      handleAddUpdateRoleProductLegalConsultation: 'handleAddUpdateRoleProductLegalConsultation'
    }),
    ...mapActions('role', {
      handleGetByCompany: 'handleGetByCompany',
      handleSetSector: 'handleSetSector',
    }),
    async showModal() {
      try {
        this.loading = false;
        await this.getRoles()
        await this.get()
        this.selected = this.sector.sectorRoles  && this.sector.sectorRoles.length > 0 ? this.sector.sectorRoles.map(x => x.roleId) : []
      } catch (e) {

      }
    },

    async create() {
      try {
        const payload = {
          _id: this.sectorId,
          rolesId: this.selected
        }
        this.loading = true
        const { data, status } = await this.handleBindRoles(payload)
        this.loading = false
        let message = data.message
        let variant = 'success'
        if (status !== 200) {
          message = data.errors
          variant = 'danger'
        }
        this.$bvToast.toast(message, {
          title: 'Atenção',
          variant: variant,
          toaster: 'b-toaster-top-center',
          autoHideDelay: 5000
        })
        await this.closeModal()
        this.$emit('update')
      } catch (e) {
      }
    },

    async get() {
      try {
        this.lookingForCompany = true
        const { data } = await this.handleGet(this.sectorId)
        const { sector } = data
        this.sector = sector
        this.lookingForCompany = false
      } catch (e) {
      }
    },

    async getRoles() {
      try {
        this.lookingForCompany = true
        const { data } = await this.handleGetByCompany(this.importedCompany._id)
        const { roles } = data
        this.roles = roles
        this.lookingForCompany = false
      } catch (e) {
      }
    },

    closeModal() {
      this.$bvModal.hide('selectRoles')
    }
  },
  created() {
  }
}
</script>
<style lang='scss' scoped>
.products-title {
  color: #262626;
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.products-sub-title {
  color: #808080;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  margin-top: -10px
}

.product {
  border-radius: 10px;
  border: 1px solid var(--navy-blue);
  padding: 5px;
  margin: 12px 12px 0 0;
}

.product-name {
  color: var(--navy-blue);
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%;
}

.product-agent {
  color: #808080;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
}

.btn-cancel {
  background: transparent !important;
  border-radius: 6.25px !important;
  border: 1px solid var(--navy-blue) !important;

  span {
    color: var(--navy-blue);
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
  }
}

.btn-add {
  background: var(--navy-blue) !important;
  border-radius: 6.25px !important;
  border: 1px solid var(--navy-blue) !important;

  span {
    color: #ffffff;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
  }
}
</style>
